import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Sanitize a URL to ensure it uses https and is from an allowed origin.
 * This is a basic security measure to prevent XSS attacks.
 */
export function sanitizeUrl(url?: string): string | undefined {
  if (!url) return undefined;
  
  try {
    const parsed = new URL(url);
    // Only allow https URLs for security
    if (parsed.protocol !== 'https:') return undefined;
    return parsed.toString();
  } catch {
    return undefined;
  }
}
